<template lang="pug">
.comments-card
  .comments-card__header
    .comments-card__user
      Avatar(:img="user.avatar", circle, size="xs")
      .comments-card__user-action
        p.comments-card__user-text(@click="openUser")
          | {{user.name}} {{user.lastname}}
        p.comments-card__user-text.comments-card__user-default
          | оставил комментарий к заданию
        p.comments-card__user-text(@click="openCourse")
          | {{comment.courseName || course}}
    Icon.comments-card__edit-icon(
      v-if="canEditComment"
      @click="toggleEditComment"
      icon="ui-pencil"
    )

  .comments-card__comment(
    v-if="!isEdit"
    v-html="commentHTML"
  )
  CommentsSend(
    v-else
    :text="comment.comment"
    :files="comment.commentatorFiles"

    @send="sendEditComment"
  )

  .comments-card__file-list(
    v-if="comment.commentatorFiles.length && !isEdit"
  )
    File(
      v-for="(file, i) in comment.commentatorFiles"
      :key="file.fileName +'_'+i"
      :file="file"
      :canDelete="false"
    )
  .comments-card__info
    p.comments-card__info-date
      | {{date}}
    p.comments-card__info-action(@click="isOpen = !isOpen")
      | {{ isOpen ? 'Закрыть' : 'Ответить' }}

    UiSwitcher.comments-card__switcher(
      :class="{'-active-': state}"
      v-model="state"
      color="gray"
      switcher="primary"
      @input="invertCommentState"
    ) {{state ? 'Прочитано' : 'Не прочитано'}}
  CommentsSend(v-if="isOpen" @send="sendComment")
  AnotherComments(
    v-if="comment.countAnother"
    :count="comment.countAnother"
    :answer="answerData"
    :comments="comment.anotherComments"
  )

</template>
<script>
import CommentsSend from './CommentsSend';
import AnotherComments from './components/AnotherComments';
import moment from 'moment';
import File from '@/components/File/File';

import textToHtmlWithLinks from '@/functions/textToHTMLWithLikns';

import { mapState } from 'vuex';

export default {
  components: {
    CommentsSend,
    AnotherComments,
    File
  },
  props: {
    comment: {
      type: Object,
      default: () => ({})
    },
    course: {},
    taskBlock: {},
    choosen: {}
  },
  data() {
    return {
      isOpen: false,
      isEdit: false,
      editComment: '',
      state: ''
    };
  },
  computed: {
    ...mapState('answersComments', {
      userList: s => s.data.comments.users
    }),
    ...mapState('auth', {
      authUserId: s => s.data.user.id
    }),
    date() {
      return moment(this.comment.createdAt.date).format('DD.MM.YYY в HH:mm:ss');
    },
    user() {
      return this.userList.find(
        user => user.authUserId === this.comment.commentator
      );
    },
    // чекаем заполненные данные из селектов
    // если данных нет, берём из запроса
    // (Если курс не выбран, то эти данные не приходят в запросе)
    variety() {
      return this.comment.variety || this.taskBlock.variety;
    },
    taskBlockQuery() {
      let taskBlock = {};

      if (this.comment.variety && this.comment.questionId) {
        taskBlock = {
          id: this.comment.questionId,
          variety: this.comment.variety
        };
      } else {
        taskBlock = this.taskBlock;
      }

      return JSON.stringify(taskBlock);
    },
    courseId() {
      return this.comment.courseId || this.choosen;
    },
    answerData() {
      return {
        id: this.comment.answerId,
        variety: this.variety
      };
    },
    commentHTML() {
      return textToHtmlWithLinks(this.comment.comment);
    },
    canEditComment() {
      return this.user.id === this.authUserId;
    }
  },
  beforeMount() {
    this.initState();
  },
  methods: {
    openUser() {},
    openCourse() {
      //записываем новый роут в переменную
      //и вызываем в новой вкладке
      const route = this.$router.resolve({
        path: '/answers/validating/feed',
        query: {
          userId: this.comment.answerUser.id,
          name: this.comment.answerUser.email,
          taskBlock: this.taskBlockQuery,
          courseId: this.courseId,
          page: 1
        }
      });
      window.open(route.href, '_blank');
    },
    sendComment(comments) {
      const data = {
        answer: {
          id: this.comment.answerId,
          comments
        },
        question: {
          variety: this.variety,
          id: this.comment.questionId
        }
      };
      this.$store.dispatch('answersComments/sendComment', data);
    },
    toggleEditComment() {
      this.isEdit = !this.isEdit;
      this.editComment = this.comment.comment;
    },
    closeEditComment() {
      this.isEdit = false;
    },
    async sendEditComment(comments) {
      const data = {
        answer: {
          id: this.comment.answerId,
          comments
        },
        question: {
          variety: this.variety,
          id: this.comment.questionId
        },
        comment: {
          id: this.comment.id
        }
      };
      this.closeEditComment();
      await this.$store.dispatch('answersComments/editComment', data);
    },
    initState() {
      this.state = !!this.comment.state;
    },
    invertCommentState() {
      this.$store.dispatch('answersComments/invertCommentState', {
        id: this.comment.id
      });
    }
  }
};
</script>
